import { type TFunction } from 'i18next';

import type { Scale } from '@/components/fields/Slider';

export const getSecondsScales = (t: TFunction) => [
  { getLabel: (count: number) => t('common:scales.time.seconds', { count }), value: 1, min: 1, max: 60 },
  { getLabel: (count: number) => t('common:scales.time.minutes', { count }), value: 60, min: 1, max: 60 }
];

export const getDaysMonthsYearsScalesByMinute = (t: TFunction): Scale[] => [
  { getLabel: (count: number) => t('common:scales.time.days', { count }), value: 1440, min: 1, max: 30 },
  { getLabel: (count: number) => t('common:scales.time.months', { count }), value: 43200, min: 1, max: 12 }
];

export const getMonthsYearsScalesByDay = (t: TFunction): Scale[] => [
  { getLabel: (count: number) => t('common:scales.time.months', { count }), value: 30, min: 1, max: 12 },
  { getLabel: (count: number) => t('common:scales.time.years', { count }), value: 365, min: 1, max: 10 }
];
